export const Colors = {
    green: '#43B97F',
    darkGreen: '#59a14d',
    lightGreen: '#43B97F',
    white: '#ffffff',
    black: '#000000',
    gray: '#f5f5f5',
    blue: '#2196F3',
    gray2: '#607474',
    darkBlue: '#00008B',
    lightBlue: '#add8e6',
    mutedBlue: '#b0c4de',
    yellow: '#ff9900',
    sunnyYellow: '#ffcc00',
    red: '#cc0000',
    brown: '#b7410e',
};
